module.exports = __webpack_public_path__ + "static/homepage-4a8d0f2fe1b58ea5c67bda572f576b41.png";